howspace.widgets.navigation = {
    initView: widget => {
        widget.on('keydown', '.workspace-card', function(e) {
            if(e.keyCode === 13 || e.keyCode === 32) {
                window.open($(this).find('a.workspace-link').attr('href'), '_blank');
                e.preventDefault();
            }
        });

        widget.on('click', '.workspace-card', function(e) {
            window.open($(this).find('a.workspace-link').attr('href'), '_blank');
            e.preventDefault();
        });
    },
    destroyView: widget => {
        // Empty for now.
    },
    initEdit: widget => {
        // Empty for now.
    },
    destroyEdit: widget => {
        // Empty for now.
    },
    save: (widget, dataPayload) => {
        if (!dataPayload.limit_results_to_workspaces) {
            dataPayload.limit_results_to_workspaces = [];
        }
        return dataPayload;
    }
};
